import * as React from "react";
import {Icon} from "../../../../../hiberUiKit/src/atoms/Icon/Icon";
import IconWrapper from "../../../../../hiberUiKit/src/atoms/Icon/IconWrapper";
import "./reconciliationModal.scss"

interface IProps {
	recommendationsLength: number;
	recommendationIndex: number;
	onNextRecommendationClick: () => void;
	onPreviousRecommendationClick: () => void;
}

export const Recommendations: React.SFC<IProps> = (props) => {
	return (
		<>
			<div className="c-reconciliation-modal_suggested-match-icon">!</div>
			<div className="c-reconciliation-modal_details-title">Suggested match</div>
			{props.recommendationsLength > 1 &&
			<div className="c-reconciliation-modal_suggested-matches-navigator">
				<IconWrapper
					disabled={props.recommendationIndex === 0}
					onClick={props.onPreviousRecommendationClick}
					icon={Icon.ArrowLeft}
					variant={"burgundy"}
					disabledVariant={"gray"}/>
				<IconWrapper
					disabled={props.recommendationIndex === props.recommendationsLength - 1}
					onClick={props.onNextRecommendationClick}
					icon={Icon.ArrowRight}
					variant={"burgundy"}
					disabledVariant={"gray"}/>
			</div>}
			{props.children}
		</>
	);
};
